import { configureStore } from '@reduxjs/toolkit';
import tableReducer from './tableSlice';
import cartReducer from './slices/cartSlice';
import loaderReducer from './slices/loaderSlice';

export const store = configureStore({
  reducer: {
    table: tableReducer,
    cart: cartReducer,
    loader: loaderReducer,
  },
});